import { Injectable } from '@angular/core';
import { ParamService } from '@monsido/core/param/param.service';


@Injectable()
export class DirectNavigationService {

    constructor (
        private paramService: ParamService,
    ) {}

    navigateToIssueOverlay (params: Record<string, string | number | boolean>): void {
        const overlayParams = Object.assign(params, {
            issueOverlay: 'true',
            time: Date.now(),
        });

        this.paramService.setParams(overlayParams);
    }
}
